import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute, Params, Router  } from '@angular/router';
import { Subscription ,  Subject } from 'rxjs';
import { config } from 'config';
import { LoaderService } from '../../../app/services/loader.service';
import { ProductViewHelperService } from 'modules/shared-postlogin/services/product-view-helper.service';
import { AssignmentViewService } from 'modules/teacher/services/assignment-view.service';
import { ApiGatewayHelperService } from '../../../app/services/apigateway-helper.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { HtmlMetaManagerService } from '../../../app/services/html-meta-manager.service';
import { ProductTocService } from 'modules/shared-postlogin/services/product-toc.service';
import translations from './../../../../assets/i18n/en';
import { ContentHelper } from 'libs-content-helper';
import { ContentAccessHelperService } from 'modules/shared-postlogin/services/content-access-helper.service';
import { CanDeactivateLPGuard } from 'modules/shared-postlogin/services/can-deactivate-lp-guard.service';
import { LtiLinkPath } from '../lti-link-path/lti-link-path.component';
import { GenericErrorModal } from 'modules/teacher/components/generic-error-modal/generic-error-modal.component'
import { PageTitleService } from 'modules/app/services/page-title.service';
@Component({
    selector: 'create-assignments',
    templateUrl: './create-assignments.template.html',
    styleUrls: ['./create-assignments.style.scss'],
    standalone: false
})
export class CreateAssignments implements OnInit, AfterViewInit, CanDeactivateLPGuard {
    @ViewChild('assignActivitiesModalForLti') assignActivitiesModalForLti: ElementRef;
    @ViewChild('deleteActivitiesModalForLti') deleteActivitiesModalForLti: ElementRef;
    @ViewChild('activitySelectionWarningModal') activitySelectionWarningModal: ElementRef;
    @ViewChild('activitySelectionWarningModalButton') activitySelectionWarningModalButton: ElementRef;
    @ViewChild('activitySelectionWarningModalCancel') activitySelectionWarningModalCancel: ElementRef;
    @ViewChild('activitySelectionSuccessModal') activitySelectionSuccessModal: ElementRef;
    @ViewChild('activitySelectionSuccessModalButton') activitySelectionSuccessModalButton: ElementRef;
    @ViewChild('activitySelectionSuccessModalCancel') activitySelectionSuccessModalCancel: ElementRef;
    @ViewChild('assignActivitiesLtiModalCancel') assignActivitiesLtiModalCancel: ElementRef;
    @ViewChild('deleteActivitiesLtiModalCancel') deleteActivitiesLtiModalCancel: ElementRef;
    @ViewChild('assignmentLimitWarningModal') assignmentLimitWarningModal: ElementRef;
    @ViewChild('assignmentLimitWarningModalButton') assignmentLimitWarningModalButton: ElementRef;
    @ViewChild('closeAssignmentLimitWarningModalButton') assignmentLimitWarningModalCloseButton: ElementRef;
    @ViewChild('launchNextActivityBtn') launchNextActivity : ElementRef;
    @ViewChild('ltiPath') LtiLinkPathComp: LtiLinkPath;
    @ViewChild(GenericErrorModal) public genericErrorModal: GenericErrorModal;
    learningpathVisible: boolean = true;
    productTocData: any;
    tocArray: any;
    paramsSubscription: Subscription;
    spaceId: string;
    productCode : string;
    classId: string;
    productMeta: any;
    linkName: string;
    selectedItemSubscription: Subscription;
    private readonly subscriptions = new Subscription();
    selectedItem : any = {};
    selectedItemData: any = {};
    nextActivityBtn = {
        show: false,
        isSecondary: false
    };    
    userProfileData: any;
    noOfCheckedItems: number = 0;
    totalItemsInProduct: number = 0;
    classTitle: string;
    classEndDate: any;
    assignmentData: any = {
        'title': '',
        'dueDate': '',
        'created': false
    }
    itemsAlreadyAssigned: any = {};
    showLoader : boolean = false;
    totalAssignmentsCount: number = 0;
    leafNodeItems: any = [];
    tocFolderDepth: number;
    ltik: string;
    ebookAssignmentFlowParams;
    public createAccessRule: boolean = false;
    public gradeActivitySelection: boolean = false;
    public tocCancelBtnClicked: boolean = false; 
    public showActivity: boolean = true;
    public ruleInfo: any;
    public productWiseClassAssignments = [];
    public imageBasePath: string = IMAGES_BASEPATH;
    public showAssignmentDetailsPage: boolean = false;
    public isEditMode: boolean = false;
    public assignmentsLOCount: number = 0;
    public isScorableActivityPresent: boolean = false;
    public isCreateRuleForAssignment: boolean = false;

    showResultScreenEvent:Subject<any> = new Subject();

    /* Boolean to show/hide result screen */
    showResultScreen: boolean = false;

    /* Array to contain all the content controls visible */
    showControls = [];

    sidebarClicked: boolean = false;
    productBundleDetails: any;
    ltiDeepLinkingMode: boolean = false;
    /* Contains all the assigned assignments items within bundle */
    itemsAlreadyAssignedInClass: any = {};
    /* Contains not assigned items of current component */
    currentComponentItemsNotAssigned: any = {};
    /* Tells whether items of this component is completely assigned or not */
    public isCurrentComponentAllItemsAssigned: boolean = false;
    tocIcon;
    public isLPv4Product: boolean = false;

    constructor(
        private route: ActivatedRoute, 
        private router: Router,
        private productViewHelperService: ProductViewHelperService,
        private loaderService: LoaderService,
        private chRef: ChangeDetectorRef,
        private assignmentViewService: AssignmentViewService,
        private appHelperService: AppHelperService,
        private readonly htmlMetaManagerService: HtmlMetaManagerService,
        private productTocService: ProductTocService,
        private apiGatewayHelperService : ApiGatewayHelperService,
        private readonly contentAccessHelperService: ContentAccessHelperService,
        private readonly pageTitleService: PageTitleService

        ) { }

    ngOnInit() {
        this.loaderService.hideLoader();
        this.productViewHelperService.setIsPreviewMode(true);

        // Product TOC data
        this.productTocData = this.route.snapshot.data.resolveData.productData; 
        this.gradeActivitySelection = this.route.snapshot.data.source === 'GRADE_ACTIVITY_SELECTION';
        this.createAccessRule = this.route.snapshot.data.source === 'CREATE_ACCESS_RULE';
        this.isEditMode = this.route.snapshot.data.source === 'TEACHER_EDIT_ASSIGNMENT';
        this.userProfileData = this.route.snapshot.data.resolveData.userProfileData;
        this.ltiDeepLinkingMode = this.router.url && this.router.url.indexOf("/ltideeplinking/") !== -1;

        this.ltik = this.route.snapshot.queryParamMap.get('ltik');
        this.tocIcon = this.productTocService.getTOCIconBasedOnTheme();
        this.paramsSubscription = this.route.params.subscribe((params: Params) => {
            // CLear previous TOC data
            this.spaceId = params.spaceid;
            this.productCode = params.productcode;
            this.classId = params.classid;
            this.apiGatewayHelperService.setSpaceId(this.spaceId);
            this.tocArray = this.productTocData.toc.tocArray;
            this.productMeta = this.productTocData.meta.meta;
            this.productBundleDetails = this.productTocData.bundleDetails;

            const bundleProduct = this.productBundleDetails.products.find( (bP) => bP['dls-product']['code'] === this.productCode);
            // Check if the current product is LPv4 product
            if (bundleProduct?.['learning-path']?.version === '4') {
                this.isLPv4Product = true;
            }

            if (this.route.snapshot.queryParams && this.route.snapshot.queryParams.currentPageLabel) {
                this.ebookAssignmentFlowParams = {
                    bundleId: this.route.snapshot.queryParams.bundleId,
                    classId: this.route.snapshot.queryParams.classId,
                    spaceId: this.route.snapshot.queryParams.spaceId,
                    bookId: this.route.snapshot.queryParams.bookId,
                    currentPageLabel: this.route.snapshot.queryParams.currentPageLabel,
                    isPplus: this.route.snapshot.queryParams.isPplus ? JSON.parse(this.route.snapshot.queryParams.isPplus) : false,
                    directToEbook: this.route.snapshot.queryParams.directToEbook
                };
            }
            let classAssignments = this.productTocData.assignmentData;

            if(classAssignments) {
                if (this.createAccessRule) {
                    // use server time to show conflict window for already assigned items while creating access rules
                    const currentTimestamp: number = this.productTocData.serverTime;
                    classAssignments.entities = classAssignments.entities.filter(assignment => assignment.duedate >= currentTimestamp && assignment.scope === 'global');
                }
                classAssignments.entities.forEach(assignment => {
                    assignment.items.forEach(item => {
                        /* Add assigned items from all the components */
                        this.itemsAlreadyAssignedInClass[item.dls_product_code + '-' + item['item-code']] = true;
                        if(item.dls_product_code === this.productCode) {
                            if (!this.productWiseClassAssignments.some((existingAssignment) => existingAssignment == assignment)) {
                                this.productWiseClassAssignments.push(assignment)
                            }
                            if(this.itemsAlreadyAssigned[item['item-code']]) {
                                this.itemsAlreadyAssigned[item['item-code']].count++;
                            } else {
                                this.itemsAlreadyAssigned[item['item-code']] = {
                                    title: assignment.title,
                                    dueDate: assignment.duedate,
                                    startDate: assignment.startdate,
                                    count: 1
                                };
                            }
                        }
                        this.assignmentsLOCount++;
                    });
                });
                this.assignmentViewService.totalAssignmentCount = this.totalAssignmentsCount = classAssignments.entities.length;
            }

            this.productViewHelperService.setProductClass(this.productCode, this.classId, this.productTocData.classmeta);
            this.classTitle = this.productTocData.classmeta.title;
            this.classEndDate = new Date(this.productTocData.classmeta.class.enddate);
            this.isClassEndedCalc();

            if(!this.createAccessRule && !this.gradeActivitySelection) {
                /* Add current component items which are not assigned */
                this.tocArray.result.forEach(unit => {
                    this.productTocService.getLeafNodeItems(unit).forEach(item => {
                        if(!ContentHelper.isTeacherOnlyContent(item) && !this.itemsAlreadyAssignedInClass[this.productCode + '-' + item['item-code']]) {
                            this.currentComponentItemsNotAssigned[this.productCode + '-' + item['item-code']] = true;
                        }
                    });
                });
                this.assignmentViewService.currentComponentItemsNotAssigned = this.currentComponentItemsNotAssigned;
                this.assignmentViewService.itemsAlreadyAssignedInClass = this.itemsAlreadyAssignedInClass;
            }

            //Setup initialization params
            var initParams = {  
                paths: {
                    dependencyBase: window.location.protocol + '//' + window.location.host + MICROAPP_BASE_URL + 'node_modules',
                    contentAssetBase: this.productMeta.paths["public-assets"]
                },
                userId: this.userProfileData.extUserId,
                userRole: this.userProfileData.role,
                orgId: this.productTocData.orgId,
                productCode: this.productCode,
                classId: this.classId,
                spaceId: this.spaceId
            };
            
            //Setup event handlers for receiving events from LO.
            var eventCallbacks = {                
                newState: (uniqueId, newState) => {
                },
                newInterpretedStatements: (uniqueId, newInterpretedStatements) => {
                },
                containerNotification: (uniqueId, containerEvent, containerEventData) => {
                    const activityEventsToBePassed = ['container_controls', 'currentScreen', 'totalScreens', 'activityClosed', 'showExitConfirmationModal'];
                    if (
                        (
                            this.selectedItemData?.[this.selectedItemData["sub-type"]]?.container === 'spa-container' ||
                            this.selectedItemData?.[this.selectedItemData["sub-type"]]?.container === 'scomp-container'
                        ) && activityEventsToBePassed.includes(containerEvent)
                    ) {
                        this.productViewHelperService.activityEventsSubject.next({ uniqueId, containerEvent, containerEventData });
                    }
                    if (containerEvent === 'avallain_controls' || containerEvent === 'generic_controls') {
                        this.showControls = this.productViewHelperService.handleControlEvent(
                            this.showControls,
                            containerEvent,
                            containerEventData,
                            this.selectedItemData?.[this.selectedItemData["sub-type"]]?.container === 'scomp-container',
                            true,
                            this.nextActivityBtn
                        );
                    } else if (containerEvent === 'iframeEvents') {
                          if (window.screen.width < 1280 && this.learningpathVisible === true) {
                            this.learningpathVisible = false;
                        } 
                    } else if (containerEvent === 'container_controls') {
                        if (containerEventData === 'activityCompleted') {
                            this.showOrHideNextActivityButton();
                        } else if (containerEventData === 'screenLaunched') {
                            this.productViewHelperService.closeActivityBtnSubject.next({ visible: true });
                        } 
                    } else if (containerEvent === 'activityClosed') {
                        this.productViewHelperService.closeActivityBtnSubject.next({ visible: false });
                        // hide C1 result screen if rendered
                        this.hideResultScreen();
                        /*launch next activity only if content terminates itself
                        ignore activityClosed event if close called by conatiner (click on 'tryAgain' button scenarios) */
                        if (!containerEventData.isContainerCloseCalled && uniqueId === this.selectedItem.activityId) {
                            this.launchNextActivity.nativeElement.click();
                        }
                    } else if (containerEvent === 'showResults') {
                        this.showResultScreenEvent.next(containerEventData);
                        this.showResultScreen = true;
                    } else if (containerEvent === 'showNextActivity') {
                        this.showOrHideNextActivityButton(containerEventData);
                    }
                    this.chRef.detectChanges();
                }
            }
            // Initialize the Activity & setup event handlers.
            this.productViewHelperService.setXAPIRunnerObject(initParams, eventCallbacks);

            //Launch first item from toc
            if (this.createAccessRule) {
                this.launchFirstContentAccessTocItem();
            } else if (!this.isEditMode) {
                this.launchFirstTocItem();
            }

            this.tocFolderDepth = this.productTocService.getTocNodeCount(this.tocArray.result);

            //important, subscribe and handle change in item 
            this.selectedItemSubscription = this.productViewHelperService.selectedItemId.subscribe(
                (selectedItemObject: any) => {
                // Hide all activity buttons by default when new activity launches
                this.showControls = [];

                this.selectedItem = selectedItemObject?.selectedItem ?? {};
                this.selectedItemData = selectedItemObject?.selectedItemData ?? {};
                
                if (!selectedItemObject) return;

                this.findUnitSelected(selectedItemObject.itemid);

                // Show Next button immediately in download type activities

                if(this.tocFolderDepth > 1) {
                    setTimeout(()=> {
                        if(ContentHelper.isDownloadableContent(selectedItemObject.selectedItemData) || ContentHelper.isSubmittableContent(selectedItemObject.selectedItemData) || ContentHelper.isCollaborativeTask(selectedItemObject.selectedItemData)) {
                            // Do not show next button in case Pskill/group pskill or Downloadable activity is the last activity of the product
                            this.showOrHideNextActivityButton();
                        } else {
                            this.nextActivityBtn = {
                                show: false,
                                isSecondary: false
                            };
                        }
                    });      
                }          
            });
        });
        this.setPageTitleAndDesc();

        if(this.route.snapshot.params['ruleid']) {
            this.ruleInfo = this.productTocData.productRules.entities.find(entity => entity.ruleid === this.route.snapshot.params['ruleid']);
        }

        if (!this.gradeActivitySelection) {
            this.contentAccessHelperService.setCurrentTime(this.productTocData.serverTime);
        }

        // To map existing lock rules
        if(!this.createAccessRule && this.productTocData.productRules) {
            const ruleMap = this.contentAccessHelperService.createRulesMap(
                this.productTocData.productRules,
                this.productTocData.classmeta.class.startdate,
                this.productTocData.classmeta.class.enddate,
                true
            );
            this.contentAccessHelperService.collectRulesOnItem(ruleMap, this.tocArray.result, this.tocFolderDepth, this.productCode);
        }   
        if(this.createAccessRule) {
            this.pageTitleService.setPageTitleToSROnlyDiv(translations.HTML_META.CREATE_RULE.TITLE +this.productMeta.title + ' ' + translations.HTML_META.LEARNINGPATH.TITLE);   
        }
        setTimeout(function() {
            const container = document.querySelector('.create-assignment-container');
            if (container) {
              container.setAttribute('aria-live', 'polite');
            }
        }, 1000); // Delay of 1 second
    }

    ngAfterViewInit() {
        this.assignmentViewService.updateClassDetailsEvent.subscribe((data)=>{
            this.productTocData.classmeta.class.enddate = data.endDate;
            this.productTocData.classmeta.class.isClassEnded = data.isClassEnded;
        });
        //set back the page title and description to default, and set show Activity, when the we are not on Activity Details Page
        this.subscriptions.add(
            this.assignmentViewService.assignmentCreationState.subscribe((res) => {
                if (!res.isAssignDetailCompShown && !this.isEditMode && !this.createAccessRule && !this.gradeActivitySelection) {
                    this.launchFirstTocItem();
                    this.setPageTitleAndDesc();
                    this.showActivity = true;
                }
                if (res.resetToc) {
                    this.showActivity = false;
                }
                // If we launch the Edit Assignment for the first time we have to launch assignment summary page
                if (this.isEditMode && !this.assignmentViewService.isExistingAssignmentInitialized) {
                    this.showActivity = false;
                    this.assignmentViewService.isExistingAssignmentInitialized = true;
                }
                if (res.isEditMode && res.isAssignDetailCompShown === false) {
                    this.launchFirstTocItem();
                    // Also, set the showActivity to true to show the activity page
                    this.showActivity = true;
                }
            })
        );

        // If on launching the edit-assignment page, if we have itemid in url then navigate back to assignment summary page
        if (this.isEditMode && this.route.snapshot?.firstChild?.params?.itemid) { 
                this.router.navigate(['../../'], { relativeTo: this.route.firstChild });
        }
    }

    private isClassEndedCalc() {
        const currentTimestamp = this.productTocData.serverTime;
        const endDate = this.classEndDate.getTime();
        if (endDate < currentTimestamp) {
            this.productTocData.classmeta.class.isClassEnded = true;
            const reactivationPeriod = endDate + config.expiredClassReactivationPeriod * 24 * 60 * 60 * 1000;
            if (currentTimestamp >= reactivationPeriod) {
                this.productTocData.classmeta.class.isClassExpired = true;
            }
        }
    }

    private setSelectedItemForActivitySelectionAndAccessRule(itemid) {
        itemid = decodeURIComponent(itemid);
        let decodedParamsArray = itemid.split('/');
        
        /* NEMO-4752 - Code is not generic for n-folder levels */
        if(decodedParamsArray.length === 1) {
            this.selectedItem = {
                ...(decodedParamsArray[0] && {activityId : decodedParamsArray[0]})
            }
        }
        else if(decodedParamsArray.length === 2) {
            this.selectedItem = {
                ...(decodedParamsArray[0] && {lessonId : decodedParamsArray[0]}),
                ...(decodedParamsArray[0] && {activityId : decodedParamsArray[0] + '/' + decodedParamsArray[1]})
            }
        }
        else {
            this.selectedItem = {
                ...(decodedParamsArray[0] && {unitId : decodedParamsArray[0]}),
                ...(decodedParamsArray[1] && {lessonId : decodedParamsArray[0] + '/' + decodedParamsArray[1]}),
                ...(decodedParamsArray[2] && {activityId : decodedParamsArray[0] + '/' + decodedParamsArray[1] + '/' + decodedParamsArray[2]}),
            };
        }
        this.selectedItemData = this.getSelectedItemData(itemid);
        this.findUnitSelected(itemid);

    }

    /* Function to get selected item data  */
    private getSelectedItemData(itemid) {
        let activityItems = [];
        let selectedItemData;
        this.productTocData.toc.tocArray.result.some((unit) => {
            activityItems = this.productTocService.getLeafNodeItems(unit);
            selectedItemData = activityItems.find((activity) => {
                let itemCode = decodeURIComponent(activity['item-code']);
                return (itemid === itemCode);
            })
            return selectedItemData;
        });
        return selectedItemData;
    }
    
    /**
     * Sets next activity button if not last item
     * @param scompEventData - Boolean value to switch the next activity button. Passed only for SComp activities
     */
    showOrHideNextActivityButton(scompEventData?: boolean) {
        if (this.selectedItemData?.[this.selectedItemData["sub-type"]]?.container === 'scomp-container' && scompEventData === false) {
            this.nextActivityBtn = {
                show: false,
                isSecondary: false
            };
            return;
        }

        let navigationArray = this.productTocData.toc.navigationMeta;
        let currentItemIndex = navigationArray.map( (val) => val["item-code"] ).indexOf(this.selectedItem.activityId);
        if ( currentItemIndex !== navigationArray.length-1 ) {
            this.nextActivityBtn = {
                show: true,
                isSecondary: false
            };
        } else {
            this.nextActivityBtn = {
                show: false,
                isSecondary: false
            };
        }
    }

    findUnitSelected (itemid): void {
        let unitid = itemid.split('/')[0];
        for(var index=0; this.tocArray.result && index<this.tocArray.result.length; index++) {            
            if (this.tocArray.result[index]['item-code'] === unitid) {
                this.selectedItem.selectedUnitIndex = index;
                break;
            }
        }
    }

    navigateToChild(itemid) {
        let queryParams = {};
        if(this.ebookAssignmentFlowParams){
            queryParams = { ...this.ebookAssignmentFlowParams };
        }

        if (this.ltik) {
            this.router.navigate(["item", itemid], { relativeTo: this.route, replaceUrl: true, queryParams: { ltik: this.ltik, ...queryParams } });    
        } else {
            this.router.navigate(["item", itemid], { relativeTo: this.route, replaceUrl: true, queryParams });
        }
    }

    /* Function to action content controls - checkAnswer/goNext/goToExerciseScreen/sendScores */
    actionControl({containerType, type}) {
        // hide C1 result screen if rendered 
        this.hideResultScreen();

        if(type === 'goToExerciseScreen' || type === 'reviewAnswers' || type === 'goPrev') {
            this.nextActivityBtn = {
                show: false,
                isSecondary: false
            };
        }
        // Action Control
        this.productViewHelperService.getXAPIRunnerObject().containerInvocation(this.selectedItem.activityId, containerType, {type});
    }

    nextActivity() {
        this.loaderService.showOverlayLoader();
        let navigationArray = this.productTocData.toc.navigationMeta;
        let currentItemIndex = navigationArray.map( (val) => val["item-code"] ).indexOf(this.selectedItem.activityId);
        // Check if next button was pressed on last activity
        if (currentItemIndex !== navigationArray.length-1 && navigationArray[currentItemIndex+1]) {
            this.navigateToChild(navigationArray[currentItemIndex+1]['item-code']);
        }        
    }

    // Function to hide C1 rendered result screen
    hideResultScreen() {
        if (this.showResultScreen) {
            this.showResultScreen = false;
        }
    }
    
    // Function to relaunch activity
    relaunchActivity() {
        this.showControls = [];
        this.nextActivityBtn = {
            show: false,
            isSecondary: false
        };
        this.productViewHelperService.getXAPIRunnerObject().reLaunchLO(this.selectedItem.activityId);
    }

    hideSidebar($event) {
        if (window.screen.width < 1280 && typeof ($event.target.className) === "string" && $event.target.className.indexOf('open-sidebar') === -1 && $event.target.parentNode && typeof ($event.target.parentNode.className) === "string" && $event.target.parentNode.className.indexOf('open-sidebar') === -1 && !this.sidebarClicked) {
            this.learningpathVisible = false;
        }
        // This variable is used to not hide sidebar when clicked on an element inside sidebar
        this.sidebarClicked = false;
    }
    
    /* Function to return true for all control types for which control needs to be shown in green */
    isControlToBeShownGreen(type) {
        switch (type) {
            case 'checkAnswer':
            // case 'goNext':
            case 'goToExerciseScreen':
            // case 'sendScores':
            case 'checkAnswers':
            case 'reviewAnswers':
            // case 'goPrev': 
            return true;
            default: return false;
        }
    }

    private transformAssignmentDataLti() {

        let assignmentDueDate = new Date(this.classEndDate.setHours(23, 59, 59, 999)).getTime();
        let assignmentTitle = this.linkName;
        
        if (assignmentDueDate > this.productTocData.classmeta.class.enddate) {
            // Assignment due date can't be after class end date
            assignmentDueDate = this.productTocData.classmeta.class.enddate;
        }
        let data = {
            title: assignmentTitle,
            duedate: assignmentDueDate,
            shared_progress: true,
            items: [],
            context: {
                'space_key': this.spaceId,
                'productcode': this.productCode,
                'bundle-code': this.productTocData.bundleDetails['bundle-code']
            },
            ext_assignedpathid: undefined
        };

        /* Safe check, as radio buttons shown in this case */
        const classProduct = this.productBundleDetails.products.find((product) => product['dls-product'].code === this.productMeta.productcode);
        const assignability = classProduct.assignability;
        let isOnlyOneItemToBeAssigned = false;
        if(assignability) {
            let itemLimit = assignability['item-limit'];
            if(itemLimit && itemLimit === 1 && this.tocFolderDepth === 0) {
                isOnlyOneItemToBeAssigned = true;
            }
        }

        this.tocArray.result.every(unit => {
            let activityItems = [];
            activityItems = this.productTocService.getLeafNodeItems(unit);
            activityItems.every(item => {
                if(item.isChecked) {
                    data.items.push({   
                        'item-code': item['item-code'],
                        'dls_product_code': this.productCode,
                        'item_type': 'dls-internal'
                    });
                    // Check if item contains a scorable activity or not.
                    // if item['sub-type'] is "ext-cup-scompscoreable", then treat it as a non-scorable activity else check using ContentHelper.isTestContent function
                    if (!this.isScorableActivityPresent) {
                        const isScompActivity = item['sub-type'] === 'ext-cup-scompscoreable';
                        const isScorable = !isScompActivity && ContentHelper.isTestContent(item);
                        if (isScorable) {
                            this.isScorableActivityPresent = true;
                        }
                    }
                    this.itemsAlreadyAssignedInClass[this.productCode + '-' + item['item-code']] = true;
                    delete this.currentComponentItemsNotAssigned[this.productCode + '-' + item['item-code']];
                    return !isOnlyOneItemToBeAssigned;
                }
                return true;
            });
            return (isOnlyOneItemToBeAssigned && data.items.length === 1) ? false : true;
        });

        return data;
    }

    public createAssignmentLti() {
        this.showLoader = true;
        let data = this.transformAssignmentDataLti();
        
        this.isCurrentComponentAllItemsAssigned  = Object.keys(this.currentComponentItemsNotAssigned).length === 0;

        /* Get FlattenedJSON paths for other components of the current bundle, if all the items from this component are assigned */
        let flattenedJSONUrlMap = {};
        if(this.isCurrentComponentAllItemsAssigned) {
            flattenedJSONUrlMap = this.assignmentViewService.getFlattenedJsonUrls(this.productTocData, this.productCode);
        }
        // https://3.basecamp.com/4489886/buckets/20201480/messages/5869627563#__recording_6215968150
        if(this.productTocData.classmeta?.ext_data?.lti_cloned) {
            data.ext_assignedpathid = 'default';
        } else {
            delete data.ext_assignedpathid;
        }
        this.assignmentViewService.createAssignment(this.spaceId, this.classId, data, flattenedJSONUrlMap).subscribe((res: any) => {
            if(res.createAssignmentData.assigned_path_id) {
                this.LtiLinkPathComp.requestDeepLinkingForm(res.createAssignmentData.assigned_path_id, data.title, this.isScorableActivityPresent);
                return;
            } else {
                this.genericErrorModal.showGenericErrorModal();
            }
            this.showLoader = false;
        }, _error => {
            this.showLoader = false;
            this.genericErrorModal.showGenericErrorModal();
        });
    }

    deleteAssignment() {
        this.showLoader = true;
        this.LtiLinkPathComp.deleteAssignment();
    }

    onAssignmentDeletion(assignmentDeleted) {
        //if assignment is deleted successfully in child component, stop the loader and close the modal
        if(assignmentDeleted) {
            this.showLoader = false;
            this.deleteActivitiesLtiModalCancel.nativeElement.click();
        }
    }

    trimSpaces() {
        this.linkName = this.linkName.replace(/^\s+/g, '');
    }

    public showActivitySelectionWarningModal(isCancelClicked = false) {
        this.tocCancelBtnClicked = isCancelClicked;
        this.activitySelectionWarningModalButton.nativeElement.click();
    }

    public showActivitySelectionSuccessModal(event) {
        this.totalItemsInProduct = event;
        this.activitySelectionSuccessModalButton.nativeElement.click();
    }

    public hideActivitySelectionWarningModal() {
        this.activitySelectionWarningModalButton.nativeElement.click();
        this.tocCancelBtnClicked = false;
    }

    private setPageTitleAndDesc() {
        let title = this.productTocData.bundleDetails.title;
        let titleDesc;
        /* Update the page description, based on the view launch */
        if (this.createAccessRule) {
            if (this.router.url.indexOf('update-access') !== -1) {
                title = translations.HTML_META.UPDATE_RULE.TITLE + this.productMeta.title;
                titleDesc = translations.HTML_META.UPDATE_RULE.DESCRIPTION;
            } else {
                title = translations.HTML_META.CREATE_RULE.TITLE + this.productMeta.title;
                titleDesc = translations.HTML_META.CREATE_RULE.DESCRIPTION;
            }
        } else if (this.gradeActivitySelection) {
            titleDesc = translations.HTML_META.LEARNINGPATH.DESCRIPTION;
        } else if(this.ltik) {
            title = translations.HTML_META.CREATE_CUSTOM_LINK.TITLE + ' ' + this.productTocData?.meta?.meta?.title + ' - ' + this.productTocData.bundleDetails.title;
            titleDesc = translations.HTML_META.CREATE_CUSTOM_LINK.DESCRIPTION;
        } else {
            title = translations.HTML_META.CREATE_ASSIGNMENT.TITLE + ' - ' + this.productTocData.bundleDetails.title;
            titleDesc = translations.HTML_META.CREATE_ASSIGNMENT.DESCRIPTION;
        }
        this.htmlMetaManagerService.setTitle(translations.HTML_META.LEARNINGPATH.TITLE, title);
        this.htmlMetaManagerService.setDescription(titleDesc);
    }

    public setNoOfCheckedItems(event) {
        this.noOfCheckedItems = event;
    }

    public showAssignmentLimitWarningModal(event: boolean) {
        if (event) {
            this.assignmentLimitWarningModalButton.nativeElement.click();
        }
    }

    public navigateToClassReviewAssignmentPage() {
        this.appHelperService.navigateToClassApp(['teacher', this.spaceId, 'class', this.classId, 'view', 'assignments']);
    }

    /**
     * Launches the first item in the TOC or finds the currently selected unit if an item is already launched.
     */
    private launchFirstTocItem() {
        if (!(this.route.firstChild && this.route.firstChild.snapshot.params.itemid)) {

            if (this.productTocData.toc.navigationMeta.length) {
                const itemId = this.productTocData.toc.navigationMeta[0]["item-code"];

                if (this.gradeActivitySelection) {
                    this.showActivity = false;
                    this.setSelectedItemForActivitySelectionAndAccessRule(itemId);
                } else {
                    this.navigateToChild(itemId);
                }
            }

            return;
        }

        // Find which unit to be set to active
        this.findUnitSelected(decodeURIComponent(this.route.firstChild.snapshot.params.itemid));
    }

    /**
     * Launches the item in the TOC for content access rule creation/updation.
     */
    private launchFirstContentAccessTocItem() { 
        if (this.route.firstChild && this.route.firstChild.snapshot.params.itemid) {
            this.showActivity = true;
            this.navigateToChild(this.route.firstChild.snapshot.params.itemid);

            return;
        }

        this.showActivity = false;

        if (this.productTocData.toc.navigationMeta.length) {
            this.setSelectedItemForActivitySelectionAndAccessRule(this.productTocData.toc.navigationMeta[0]["item-code"]);
        }
    }

    canDeactivate() {
        // No statements to send OR cleanup to do
        return true;
    }

    ngOnDestroy() {
        this.pageTitleService.setPageTitleToSROnlyDiv('');   
        this.paramsSubscription.unsubscribe();
        this.selectedItemSubscription.unsubscribe();
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
        if (this.assignActivitiesModalForLti.nativeElement.classList.contains('show')) {
            this.assignActivitiesLtiModalCancel.nativeElement.click();
        }
        if (this.deleteActivitiesModalForLti.nativeElement.classList.contains('show')) {
            this.deleteActivitiesLtiModalCancel.nativeElement.click();
        }
        if (this.activitySelectionWarningModal.nativeElement.classList.contains('show')) {
            this.activitySelectionWarningModalCancel.nativeElement.click();
        }
        if (this.activitySelectionSuccessModal.nativeElement.classList.contains('show')) {
            this.activitySelectionSuccessModalCancel.nativeElement.click();
        }
        if (this.assignmentLimitWarningModal.nativeElement.classList.contains('show')) {
            this.assignmentLimitWarningModalCloseButton.nativeElement.click();
        }
    }
}